/**
 * Flat fill classes, written out in full so Tailwind can see them. Text on every one of these
 * is ink, except grape and ink fills, which take white text (contrast.test.ts checks them all).
 */
export type Tone = 'white' | 'pale' | 'lilac' | 'lavender' | 'sky' | 'mint' | 'butter' | 'peach' | 'grape' | 'ink';

export const TONE_BG: Record<Tone, string> = {
  white: 'bg-white text-ink',
  pale: 'bg-lilac-pale text-ink',
  lilac: 'bg-lilac text-ink',
  lavender: 'bg-lavender text-ink',
  sky: 'bg-sky text-ink',
  mint: 'bg-mint text-ink',
  butter: 'bg-butter text-ink',
  peach: 'bg-peach text-ink',
  grape: 'bg-grape text-white',
  ink: 'bg-ink text-white',
};

/** Hex values for SVG and canvas, same order as TONE_BG. */
export const TONE_HEX: Record<Tone, string> = {
  white: '#ffffff',
  pale: '#edd0e4',
  lilac: '#cb94c2',
  lavender: '#e2a4ff',
  sky: '#97f0ff',
  mint: '#92ffa7',
  butter: '#ffffa1',
  peach: '#ffc299',
  grape: '#813f98',
  ink: '#000000',
};

/** The pastel ramp in stack order, used for avatars, confetti and charts. */
export const PASTELS = ['lavender', 'sky', 'mint', 'butter', 'peach'] as const satisfies readonly Tone[];
